module.exports = __webpack_public_path__ + "img/solution_back1.343b6def.png";